import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import { cancelTokenSelector, hashSelector } from '../redux/selectors/selectors';
import { useQuery } from '@tanstack/react-query';
import * as browserStorage from '../misc/BrowserStorageManager';

function usePlaybackTokenDetailsByJti({ jti, from, to }) {
   const jwtToken = browserStorage.getJwtToken();
   const cancelToken = useSelector(cancelTokenSelector);
   const hash = useSelector(hashSelector);

   const effectiveTo = useMemo(() => {
      const toMoment = moment.utc(to);
      const threeDaysAgo = moment.utc().subtract(3, 'days');
      return toMoment.isAfter(threeDaysAgo) ? moment.utc().add(1, 'hour').format() : toMoment.format();
   }, [to]);

   const httpHeader = useMemo(
      () => ({
         'x-access-token': jwtToken,
         'Content-Type': 'application/json',
         ...(hash ? { 'x-orga-hash': hash } : {}),
      }),
      [jwtToken, hash],
   );

   const { data, isLoading, error } = useQuery({
      enabled: !!jti && !!from && !!effectiveTo,
      queryKey: ['tokenByJti', jti, from, effectiveTo, hash],
      queryFn: () =>
         axios
            .get('/v2/misc/token/playback/details', {
               params: { jti, from, to: effectiveTo },
               headers: httpHeader,
               cancelToken: cancelToken.token,
            })
            .then((res) => res.data.tokenDetails),
      retry: false,
      refetchOnWindowFocus: false,
   });

   return {
      tokenDetails: data,
      isLoading,
      error,
   };
}

export default usePlaybackTokenDetailsByJti;
